import { createFileRoute } from "@tanstack/react-router";

import { OrgGeneralContainer } from "@/features/organisation/containers/org-general-container";

export const Route = createFileRoute("/organisation/general")({
  component: OrgGeneralContainer,
});
